import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { State } from 'src/app/models/state';

@Injectable({
  providedIn: 'root'
})
export class DataStoreService {
  private state = new BehaviorSubject<State>({
    authUser: null,
    currentUser: null,
    currentAccount: null,
    organization: null
  });
  private state$ = this.state.asObservable();

  constructor() {}

  getState$(): Observable<{ newState: State; oldState: State | null }> {
    let oldState: State | null = null;
    return new Observable(observer => {
      this.state$.subscribe(newState => {
        observer.next({ newState, oldState });
        oldState = newState;
      });
    });
  }

  updateState(partialState: Partial<State>): void {
    const currentState = this.state.value;
    const newState = { ...currentState, ...partialState };
    this.state.next(newState);
  }

  getProperty<K extends keyof State>(key: K): State[K] {
    return this.state.value[key];
  }

  getAuthStateProperty(key: string, shouldParse: boolean = true): any {
    const value = localStorage.getItem(key);
    if (!value) return null;
    return shouldParse ? JSON.parse(value) : value;
  }

  setAuthStateProperty(key: string, value: any, shouldStringify: boolean = true): void {
    const storageValue = shouldStringify ? JSON.stringify(value) : value;
    localStorage.setItem(key, storageValue);
  }

  removeAuthStateProperty(key: string): void {
    localStorage.removeItem(key);
  }
}